<template>
  <div id="waiter">
    <app-icon
      :name="icon"
      size="small"
      id="waiter-icon"
      :color="color || '#fff'" />
    <svg class="progress-ring">
      <circle
        class="progress-ring__circle"
        stroke="#7BB9F6"
        stroke-width="6"
        :stroke-dasharray="circleDasharray"
        fill="transparent"
        r="47"
        cx="50"
        cy="50"/>
    </svg>
  </div>

</template>

<style lang="sass" scoped>
#waiter
  align-items: center
  display: flex
  height: 100px
  justify-content: center
  position: relative
  width: 100px
#waiter-icon
.progress-ring
  position: absolute
  height: 100%
  width: 100%
.progress-ring__circle
  transition: 0.35s stroke-dashoffset
  transform: rotate(-90deg)
  transform-origin: 50% 50%

</style>

<script>
import AppIcon from '@/components/icons/AppIcon.vue';

export default {
  name: 'Progress',

  components: {
    AppIcon,
  },

  props: {
    color: String,
    icon: String,
    relativeProgress: Number,
  },

  data() {
    return {
      FULL_DASH_ARRAY: 283,
    };
  },

  computed: {
    circleDasharray() {
      return `${(this.relativeProgress * this.FULL_DASH_ARRAY).toFixed(0)} 283`;
    },
  },
};
</script>
